/**
 * Philips Device Connector button event bitmasks (Event Mode).
 * @see https://www.dictation.philips.com/fileadmin/Products/pcl8010/ifu/PDCsampleWebsite.html
 */
import { PHILIPS_CMD } from "./philipsSpeechMikeActions";

export const PDC_BUTTON = {
  FRWD: 1,
  PLAY: 2,
  FFWD: 4,
  INSOVR: 16,
  REC: 32,
  CMD: 64,
  STOP: 256,
  INSTR: 512,
  F1: 1024,
  F2: 2048,
  F3: 4096,
  F4: 8192,
  EOL: 16384,
};

/**
 * Maps PDC button bitmasks to shared SpeechMike commands (F-key parity).
 *
 * Keyboard mode          PDC Event Mode button
 * ─────────────────────  ─────────────────────────────
 * F2                     F2
 * REC (record)           Sidebar mic (right transcription)
 * PLAY                   Editor dictation (report mic)
 * F3                     F3 (editor dictation)
 * Shift+F3               CMD
 * F4                     F4, FFWD (F6 alt)
 * Shift+F4               FRWD
 * F7                     F1
 * F8                     INSTR
 * F9                     EOL
 * F10                    INSOVR
 * —                      STOP (stop active dictation)
 */
export const PDC_BUTTON_TO_COMMAND = [
  [PDC_BUTTON.F2, PHILIPS_CMD.SIDEBAR_MIC],
  [PDC_BUTTON.F3, PHILIPS_CMD.EDITOR_DICTATION],
  [PDC_BUTTON.REC, PHILIPS_CMD.SIDEBAR_MIC],
  [PDC_BUTTON.PLAY, PHILIPS_CMD.EDITOR_DICTATION],
  [PDC_BUTTON.CMD, PHILIPS_CMD.COMMAND_MODE],
  [PDC_BUTTON.F4, PHILIPS_CMD.NEXT_PARAGRAPH],
  [PDC_BUTTON.FFWD, PHILIPS_CMD.NEXT_PARAGRAPH],
  [PDC_BUTTON.FRWD, PHILIPS_CMD.PREV_PARAGRAPH],
  [PDC_BUTTON.F1, PHILIPS_CMD.IMPRESSION],
  [PDC_BUTTON.INSTR, PHILIPS_CMD.FINDINGS],
  [PDC_BUTTON.EOL, PHILIPS_CMD.SAVE],
  [PDC_BUTTON.INSOVR, PHILIPS_CMD.PROCESS_AI],
  [PDC_BUTTON.STOP, PHILIPS_CMD.STOP_DICTATION],
];

/**
 * @param {number} eventMask
 * @param {number} previousMask
 * @returns {string[]}
 */
export function pdcCommandsForNewlyPressedButtons(eventMask, previousMask) {
  const newlyPressed = eventMask & ~previousMask;
  if (!newlyPressed) return [];

  const commands = [];
  for (const [buttonMask, command] of PDC_BUTTON_TO_COMMAND) {
    if (newlyPressed & buttonMask) {
      commands.push(command);
    }
  }
  return commands;
}
